export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["NAVIGATE_TO"] = "NAVIGATE_TO";
    ActionTypes["SELECT_NAVIGATION_ITEM"] = "SELECT_NAVIGATION_ITEM";
    ActionTypes["SET_INVENTORY_SEARCH"] = "SET_INVENTORY_SEARCH";
    ActionTypes["SET_DISPLAY_FILTERS"] = "SET_DISPLAY_FILTERS";
})(ActionTypes || (ActionTypes = {}));
